import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {store} from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import {BrowserRouter} from 'react-router-dom';
import {ConnectionChanel} from './services';
import {PersistGate} from 'redux-persist/integration/react';
import persistStore from 'redux-persist/es/persistStore';
import {AppErrorBoundary} from './components/common/AppErrorBoundary';

const container = document.getElementById('root')!;
const root = createRoot(container);
const persistor = persistStore(store);
root.render(
    <React.StrictMode>
        {/* Outermost on purpose: a crash inside the store, the rehydration or the router is exactly the
            kind this catches, so it has to sit above all three. */}
        <AppErrorBoundary>
            <Provider store={store}>
                <PersistGate
                    loading={null}
                    persistor={persistor}
                >
                    <BrowserRouter>
                        <App connect={new ConnectionChanel()}/>
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </AppErrorBoundary>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
